// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___kFstq {
     background-color: #ffffff;
    border-radius: 10px;
    align-self: flex-start; /* this might not work in all scenarios in CSS as expected */
    padding: 6px 8px; /* paddingVertical and paddingHorizontal */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 4px 2px rgba(96, 96, 255, 0.25); /* shadowColor, shadowOffset, shadowOpacity, shadowRadius */
    cursor: pointer;
    transition: box-shadow 0.3s ease;
}

.style__container___kFstq:hover {
     box-shadow: 0 0 8px 4px rgba(96, 96, 255, 0.25);
}

.style__text___SXdiN {
    font-size: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Buttons/ActionButton/style.css"],"names":[],"mappings":"AAAA;KACK,yBAAyB;IAC1B,mBAAmB;IACnB,sBAAsB,EAAE,4DAA4D;IACpF,gBAAgB,EAAE,0CAA0C;IAC5D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,+CAA+C,EAAE,2DAA2D;IAC5G,eAAe;IACf,gCAAgC;AACpC;;AAEA;KACK,+CAA+C;AACpD;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".container {\n     background-color: #ffffff;\n    border-radius: 10px;\n    align-self: flex-start; /* this might not work in all scenarios in CSS as expected */\n    padding: 6px 8px; /* paddingVertical and paddingHorizontal */\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0 0 4px 2px rgba(96, 96, 255, 0.25); /* shadowColor, shadowOffset, shadowOpacity, shadowRadius */\n    cursor: pointer;\n    transition: box-shadow 0.3s ease;\n}\n\n.container:hover {\n     box-shadow: 0 0 8px 4px rgba(96, 96, 255, 0.25);\n}\n\n.text {\n    font-size: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___kFstq`,
	"text": `style__text___SXdiN`
};
export default ___CSS_LOADER_EXPORT___;
